import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { useTabNavContext } from '../../tab-nav-context';
import { useProductPageNavExperiment } from 'src/hooks/experiments';
import { Tab } from 'src/components/sticky-tab-nav/types';
import { TabAnchor } from '../product-tabs/types';
import { ProductNavigationLink } from './styles';

export const useNavigationLinks = (): Tab[] => {
  const { t } = useAppContext();
  const { shouldFetch, setShouldFetch } = useTabNavContext();
  const newTabNav = useProductPageNavExperiment();

  const setFetchContentBool = (tabAnchor: TabAnchor) => {
    // Prevent fetching tab content data if tab content data has aldready been fetched.
    if (shouldFetch?.includes(tabAnchor)) return null;
    return setShouldFetch(state => [...(state || []), tabAnchor]);
  };

  return [
    {
      id: TabAnchor.ALL,
      title: (
        <ProductNavigationLink data-test="TabButton" data-test-section="main">
          {t('product', 'tabs.prices')}
        </ProductNavigationLink>
      ),
      scrollToTop: true,
    },
    {
      id: TabAnchor.REVIEWS,
      title: (
        <ProductNavigationLink
          data-test="TabButton"
          data-test-section="reviews"
        >
          {t('product', 'tabs.reviews')}
        </ProductNavigationLink>
      ),
      tabCallback: newTabNav
        ? () => setFetchContentBool(TabAnchor.REVIEWS)
        : undefined,
    },
    {
      id: TabAnchor.STATISTICS,
      title: (
        <ProductNavigationLink
          data-test="TabButton"
          data-test-section="statistics"
        >
          {t('product', 'tabs.price-history')}
        </ProductNavigationLink>
      ),
      tabCallback: newTabNav
        ? () => setFetchContentBool(TabAnchor.STATISTICS)
        : undefined,
    },
    {
      id: TabAnchor.PROPERTIES,
      title: (
        <ProductNavigationLink
          data-test="TabButton"
          data-test-section="properties"
        >
          {t('product', 'tabs.properties')}
        </ProductNavigationLink>
      ),
      tabCallback: newTabNav
        ? () => setFetchContentBool(TabAnchor.PROPERTIES)
        : undefined,
    },
  ];
};
